const getModalGradient = (color1: string, color2: string) =>
	`linear-gradient(92.69deg, ${color1} 25.25%, ${color2} 123.64%)`;

export default getModalGradient;
